/**
 * Core-Matrix 5 / 10 / 85 — kopie van src/utils/academyMatrix.ts (server). Hele centen,
 * half naar boven afgerond: identiek aan Postgres round(numeric, 2) en aan de server,
 * zodat een preview in de UI nooit een cent afwijkt van de factuur.
 */
export const MATRIX_KORTING_PCT = 5;
export const MATRIX_PLATFORMFEE_PCT = 10;

export interface MatrixSplitsing {
  marktprijs: number;
  korting_bedrag: number;
  activeringswaarde: number;
  platformfee_bedrag: number;
  opleider_netto: number;
}

const pctVan = (centen: number, pct: number) => Math.round((centen * pct) / 100);

export function berekenMatrix(
  marktprijs: number,
  kortingPct = MATRIX_KORTING_PCT,
  platformfeePct = MATRIX_PLATFORMFEE_PCT
): MatrixSplitsing {
  const markt = Math.max(0, Math.round((Number(marktprijs) || 0) * 100));
  const korting = pctVan(markt, kortingPct);
  const fee = pctVan(markt, platformfeePct);
  return {
    marktprijs: markt / 100,
    korting_bedrag: korting / 100,
    activeringswaarde: (markt - korting) / 100,
    platformfee_bedrag: fee / 100,
    opleider_netto: (markt - korting - fee) / 100,
  };
}
